const interestOptions = [
    { label: "Design", interests: ["UX/UI", "UXR", "Graphic", "Brand"], color: "#BD17C0" },
    { label: "Code", interests: ["Frontend", "Backend", "Full Stack", "AI/ML", "Quant", "QA", "Game Dev", "SRE"], color: "#8B32EB"  },
    { label: "PM", interests: ["Product", "Project", "Program"], color: "#413ce2"  },
    { label: "Mech", interests: ["CAD/Simulation", "Manufacturing", "Materials", "Automotive", "Aero"], color: "#24a9d9"  },
    { label: "Elec", interests: ["Embedded", "Signals", "Sensors", "Robotics", "Power Systems", "Communications"], color: "#30CFAA"  },
    { label: "Other", interests: ["Data", "Business", "VC", "IDK Yet!", "Other"], color: "#868686"  }
];

export default interestOptions;
